import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { ErrorComponent } from 'app/popup/error.component';
import { AlertComponent } from 'app/popup/alert.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { PermitTypeService } from 'app/services/permit-type.service';
import { ToastrService } from 'ngx-toastr';
import {TableModule, Table} from 'primeng/table';
import {AutoCompleteModule} from 'primeng/autocomplete';

@Component({
  selector: 'app-list-permit-type',
  templateUrl: './list-permit-type.component.html',
  styleUrls: ['./list-permit-type.component.css']
})
export class ListPermitTypeComponent implements OnInit {

  pTypes: any = [];
  isRemove = false;
  removeRef: any;    
  lblHeading = '';
  loading: boolean = true;
  @ViewChild('tbpTypes ') table: Table;

  popoverTitle = 'Delete Vehicle Make';
  popoverMessage = 'Are you sure you want to delete Permit Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Permit Types...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private permitService: PermitTypeService, public utility: UtilityServiceService,private toastr:ToastrService) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.permitService.getAll().subscribe(result => {
      this.pTypes = result;
      this.utility.onSort(1);
      //console.log(this.pTypes);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
      //console.log(error);
    });
  }

  onDelete(id: any) {
    this.permitService.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Permit Type', message: `Permit Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Permit Type ${this.removeRef.code} deleted.`,'Delete Permit Type');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Permit Type', message: `Permit Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Permit Type ${this.removeRef.code} was not deleted.`,'Delete Permit Type');
    });
  }
  
  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Permit Type <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Permit Types' : 'Delete Permit Type';
  }

  showIndicator = (indicator: number, type = 1) => {
    return (type == 1) ? (indicator == 1) ? 'Freight' : 'Passenger' : (indicator == 1) ? 'Temporary' : 'Long-term';   
  }

  showPeriod = (obj: any) => {
    let msg = '';
    if (obj.permit_days > 0) {
      msg = `Permit days {${obj.permit_days}}`;
    }
    else if (obj.permit_months > 0) {
      msg = `Permit months {${obj.permit_months}}`;
    }
    else if (obj.permit_years > 0) {
      msg = `Permit years {${obj.permit_years}}`;
    }
    return msg;
  }

  onActivityChange(event) {
    const value = event.target.value;
    if (value && value.trim().length) {
        const activity = parseInt(value);

        if (!isNaN(activity)) {
            this.table.filter(activity, 'activity', 'gte');
        }
    }
}

}
